import { v4 as uuid } from "uuid";
import * as UserConst from "actions/userConst";
import { useSelector, useDispatch } from 'react-redux'

import store from '@/redux/store';
import { createSlice, nanoid, createAsyncThunk } from '@reduxjs/toolkit'
import AdminUserAPI from "@/api/AdminUserAPI";

import { show } from '@/reducers/Modal'
import {ADMINUSER} from "@/actions/globalConst";
import  {UserModel} from "@/models/User";
import {AddressModel} from "@/models/Address";

import { NotificationModel } from "@/models/Notification";
import {add} from "@/reducers/NotificationReducer";

export const initialState = {
  showModal: "",
  isInProgress: false,
  showSheet: false,
  status: ADMINUSER.API_INIT,
  view: false,
  users: false,
  selected: false,
  userfields: false,
  key: "",
  interests: [],
  user_interests: [],
  roles: [],
};

export const loadUsers = createAsyncThunk(
  ADMINUSER.LOAD_USERS,
  // The payload creator receives the partial `{title, content, user}` object
  async (usertype, event) => {
      //const {UserReducer, rejectWithValue} = event.getState();
      let response = null;
      try {
      response = await AdminUserAPI.get(usertype);
      return response.data;
    } catch (err) {

      // Use `err.response.data` as `action.payload` for a `rejected` action,
      // by explicitly returning it using the `rejectWithValue()` utility
      return event.rejectWithValue({status: err.response.status, statusText: err.response.statusText, data: err.response.data})
    }
      return response;
  }
)

export const loadUser = createAsyncThunk(
  ADMINUSER.LOAD_USER,
  // The payload creator receives the partial `{title, content, user}` object
  async (userId, event) => {
      //const {UserReducer, rejectWithValue} = event.getState();
      let response = null;
      try {
      response = await AdminUserAPI.getUser(userId);
      return response.data;
    } catch (err) {

      // Use `err.response.data` as `action.payload` for a `rejected` action,
      // by explicitly returning it using the `rejectWithValue()` utility
      return event.rejectWithValue({status: err.response.status, statusText: err.response.statusText, data: err.response.data})
    }
      return response;
  }
)

export const saveUserData = createAsyncThunk(
  ADMINUSER.STORE,
  // The payload creator receives the partial `{title, content, user}` object
  async (data, event) => {
      //const {UserReducer, rejectWithValue} = event.getState();
      let response = null;
      try {
      response = await AdminUserAPI.saveUser(data);
      return response.data;
    } catch (err) {

      // Use `err.response.data` as `action.payload` for a `rejected` action,
      // by explicitly returning it using the `rejectWithValue()` utility
      return event.rejectWithValue({status: err.response.status, statusText: err.response.statusText, data: err.response.data})
    }
      return response;
  }
)


const AdminUserReducer = createSlice({
  name: 'adminUser',
  initialState,
  reducers: {
  },
  extraReducers(builder) {
     builder.addCase(loadUsers.fulfilled, (state, action) => {

      // We can directly add the new post object to our posts array
      state.status = ADMINUSER.API_READY
      state.view = ADMINUSER.VIEW_OVERVIEW
        state.users = action.payload.data.data;
        state.userfields = false;
        state.selected = false;
        state.key = uuid().slice(0, 8);
    })      
    .addCase(loadUsers.rejected, (state, action) => {
        state.users = false;
        state.status = ADMINUSER.API_ERROR
        state.error = action.payload;
      })
     builder.addCase(saveUserData.fulfilled, (state, action) => {
      state.view = ADMINUSER.VIEW_OVERVIEW
        state.selected = false;
        state.userfields = false;

    });
          
     builder.addCase(loadUser.fulfilled, (state, action) => {

      // We can directly add the new post object to our posts array
      state.status = ADMINUSER.API_READY
      state.view = ADMINUSER.VIEW_DETAIL
        state.selected = action.payload.data.data;
        state.userfields = action.payload.data.ppcUserFields;
        state.key = uuid().slice(0, 8);
    })      
    .addCase(loadUser.rejected, (state, action) => {
        state.selected = false;
        state.status = ADMINUSER.API_ERROR
        state.error = action.payload;
      })
      
  }
})
//export const { unsetSelected } = UserReducer.actions;
export default AdminUserReducer.reducer